export const FETCH_FERTILIZER = 'FETCH_FERTILIZER';
export const FETCH_FERTILIZER_SUCCESS = 'FETCH_FERTILIZER_SUCCESS';